/**
 * gRPC logger level enumeration
 */
export enum GrpcLogLevel {
    DEBUG = 'debug',
    VERBOSE = 'verbose',
    LOG = 'log',
    WARN = 'warn',
    ERROR = 'error',
}
